import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';
import SideBarAlarm, {SideBarAlarmContainer} from './SideBarAlarm';

const AlarmsListContainer = styled.div`
  & ${SideBarAlarmContainer}:last-child {
    border: none;
    margin-left: -18px;
  }
`;

const SideBarAlarmList = ({alarms = []}) => (
  <AlarmsListContainer>
    {alarms.map((alarm, i) => <SideBarAlarm alarm={alarm} key={i} />)}
  </AlarmsListContainer>
);

SideBarAlarmList.propTypes = {
  alarms: t.arrayOf({
    code: t.string,
    text: t.string,
    category: t.string,
    start: t.string
  })
};

export default SideBarAlarmList;
